import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FactuaContextProps {
  isOpen: boolean;
  iframeLink: string;
  openFactua: (link: string) => void;
  closeFactua: () => void;
}

const FactuaContext = createContext<FactuaContextProps | undefined>(undefined);

export const FactuaProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [iframeLink, setIframeLink] = useState<string>('');

  const openFactua = (link: string): void => {
    setIframeLink(link);
    setIsOpen(true);
  };

  const closeFactua = (): void => {
    setIsOpen(false);
    setIframeLink('');
  };

  return (
    <FactuaContext.Provider value={{ isOpen, iframeLink, openFactua, closeFactua }}>
      {children}
    </FactuaContext.Provider>
  );
};

export const useFactua = (): FactuaContextProps => {
  const context = useContext(FactuaContext);
  if (!context) {
    throw new Error('useFactua must be used within a FactuaProvider');
  }
  return context;
};
